import { RelayApi } from 'api/ApiHelper';
import { useQuery } from '@tanstack/react-query';
import { studioQueryKey } from 'queries/studio/queryKey';

export const usePostRelayWorkspaceContentsQuery = ({
  contentIds,
  includeAdult,
}: {
  contentIds: number[];
  includeAdult: boolean;
}) =>
  useQuery({
    queryKey: studioQueryKey.contentList(contentIds),
    queryFn: () => RelayApi.workspaceContents({ contentIds, includeAdult }),
    enabled: contentIds.length > 0,
  });
